"use client";

import { usePageRuntime } from "@newxsystems/fe-engine/page-runtime";
import type { MegaMenuItem } from "./MegaMenuBlock.props";
import { MegaMenuDesktopNavInner } from "./MegaMenuDesktopNav.inner";

export const MegaMenuDesktopNav = ({ items }: { items?: MegaMenuItem[] }) => {
  const { pathname: currentPath } = usePageRuntime();

  if (!items?.length) return null;

  return <MegaMenuDesktopNavInner currentPath={currentPath} items={items} />;
};
